module.exports = __webpack_public_path__ + "img/ss_inbox_control.1bf94aa0.png";